import * as React from 'react';

import StoreProviderWrapper from 'bundles/ai-coach-platform/components/patterns/chat/store/StoreProviderWrapper';
import SearchBarContentWrapper from 'bundles/search-common/components/searchbar/SearchBarContentWrapper';
import type { EnterpriseSearchBarConfig } from 'bundles/search-common/components/searchbar/searchBarWrapperTypes';

type Props = {
  enterpriseSearchBarConfig: EnterpriseSearchBarConfig;
  searchIsOpen?: boolean;
  hideMobileSearchPage?: () => void;
};

const EnterpriseSearchBar = ({ enterpriseSearchBarConfig, searchIsOpen, hideMobileSearchPage }: Props) => {
  return (
    <StoreProviderWrapper>
      <SearchBarContentWrapper
        searchBarConfig={{
          enterpriseSearchBarConfig,
        }}
        searchIsOpen={searchIsOpen}
        hideMobileSearchPage={hideMobileSearchPage}
      />
    </StoreProviderWrapper>
  );
};

export default EnterpriseSearchBar;
